export const readTabSessionValue = (key: string): string | null => {
  const sessionValue = globalThis.window.sessionStorage.getItem(key);

  if (sessionValue !== null) {
    globalThis.window.localStorage.removeItem(key);
    return sessionValue;
  }

  const legacyValue = globalThis.window.localStorage.getItem(key);

  if (legacyValue === null) {
    return null;
  }

  globalThis.window.sessionStorage.setItem(key, legacyValue);
  globalThis.window.localStorage.removeItem(key);

  return legacyValue;
};

export const writeTabSessionValue = (key: string, value: string): void => {
  globalThis.window.sessionStorage.setItem(key, value);
  globalThis.window.localStorage.removeItem(key);
};

export const removeTabSessionValue = (key: string): void => {
  globalThis.window.sessionStorage.removeItem(key);
  globalThis.window.localStorage.removeItem(key);
};
